import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/index';
import SliderOnly from '../slider';
import { Input, Button, message } from 'antd';
import { apiGetCaptchaWord, apiAccountLogin, apiPostPhoneCaptcha, apiLoginByPhoneCaptcha } from '../../request/api';
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface PhoneVerificationProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
}

const PhoneVerification: React.FC<PhoneVerificationProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();
    const [identifyingString, setIdentifyingString] = useState<string | null | undefined>('发送验证码');
    const [countdown, setCountdown] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [captcha, setCaptcha] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [sliderOnly, setSliderOnly] = useState(0);
    const [ok, setOk] = useState(0);
    const { getValue, customData } = useCustomData();
    const [messageApi, contextHolder] = message.useMessage();
    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "", email: "", phone: "", password: "", verification: "", account: "", emailError: "", sendVerification: "",
        phoneError: "", accountError: "", passwordError: "", verificationError: "", enterAccount: "", enterEmail: "",
        enterPassword: "", enterPasswordAgain: "", enterVerification: "", enterPhone: "", forget: "", verifyIdentityFor: "",
        getBack: "", next: "", check1: "", verifyIdentity: "", resetPassword: "", orInfo: "", backLogin: "", seccond: "", changeInfo: "",
        sendIdentifying: ''
    });

    useEffect(() => {
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
        };
        setIdentifyingString(getValue('sendIdentifying'))
        setLoginInfo(newLoginInfo);
    }, [customData]);


    const handleGetCode = () => {
        if (sliderOnly == 0) {
            messageApi.open({
                type: 'error',
                content: '请进行验证',
            });
        } else {
            apiGetCaptchaWord({
                key: data.phone
            }).then(res => {
                console.log(res);
                setIsButtonLoading(true);
                setTimeout(() => {
                    apiPostPhoneCaptcha({
                        captcha: res.data.data,
                        phone: data.phone
                    }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(phoneres => {
                        console.log(phoneres);
                        messageApi.open({
                            type: 'success',
                            content: phoneres.data.data,
                        });
                        setIsButtonDisabled(true);
                        setCountdown(60);
                        setIsButtonLoading(false);
                    });
                }, 3000);
            }).catch(err => {
                console.log(err);
            });
        }
    };

    const goLogin = () => {
        // 验证逻辑移到这里
        if (ok === 0) {
            if (captcha.length < 6) {
                setError(loginInfo.verificationError || '验证码长度不足6位');
                return;
            }
            apiLoginByPhoneCaptcha({
                phone: data.phone,
                smsCaptcha: captcha
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.ret === '40106') {
                    messageApi.open({
                        type: 'error',
                        content: res.data.msg,
                    });
                } else {
                    messageApi.open({
                        type: 'success',
                        content: res.data.msg,
                    });
                    const token = res.data.data.token;
                    localStorage.setItem('userToken', token);
                    navigate('/mine');
                }
            });
        } else {
            if (password.length < 6) {
                setError(loginInfo.passwordError || '密码长度不足6位');
                return;
            }
            apiAccountLogin({
                accountName: data.phone,
                password: password,
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                const token = res.data.data.token;
                localStorage.setItem('userToken', token);
                navigate('/mine');
            }).catch(err => {
                console.error('登录失败:', err);
                messageApi.open({
                    type: 'error',
                    content: '登录失败',
                });
            });
        }
    };

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);

            return () => clearTimeout(timer);
        } else if (countdown === 0) {
            setIsButtonDisabled(false);
        }
    }, [countdown]);

    const onSuccess = () => {
        setSliderOnly(1);
    };

    const onError = () => {
        alert('滑动验证失败，请重试。');
    };

    const toAcountVerification = () => {
        handleViewChange('loadAccount', data.phone);
    };

    const backToLoginPage = () => {
        handleViewChange('mainLogin', data.phone);
    };

    return (
        <div>
            {contextHolder}
            <div className='login-header'>{loginInfo.loginName}</div>
            <div className='login-body'>
                <span>{data.phone}</span>
                <span onClick={backToLoginPage} className='cursur' style={{ color: themeColor, cursor: 'pointer' }}>{loginInfo.changeInfo}</span>
            </div>
            <div className='login-text' style={{ marginTop: '24px' }}>
                {[loginInfo.verification, loginInfo.password].map((item, index) => (
                    <span key={index} className='login-switch'
                        onClick={() => {
                            setOk(index);
                            setError('');
                            setCaptcha('');
                            setPassword('');
                            setSliderOnly(0);
                        }}
                        style={{
                            color: index === ok ? themeColor : 'inherit',
                            cursor: 'pointer'
                        }}>{item}</span>
                ))}
            </div>
            {ok === 0 && (
                <div className="slider-wrapper" style={{ marginBottom: '30px' }}>
                    <SliderOnly
                        width={360}
                        fragmentSize={40}
                        onSuccess={onSuccess}
                        onError={onError}
                        color={themeColor}
                        tdrage={getValue('tdrage')}
                        inforScuess={getValue('inforScuess')}
                    />
                </div>
            )}
            {ok === 0 && (
                <div className='login-body-native'>
                    <Input
                        status={error ? 'error' : ''}
                        placeholder={loginInfo.enterVerification}
                        value={captcha}
                        onChange={(e) => {
                            setCaptcha(e.target.value);
                            // 添加输入时错误清除
                            if (e.target.value.length >= 6) {
                                setError(null);
                            }
                        }}
                    />
                    <Button disabled={isButtonDisabled} onClick={handleGetCode} loading={isButtonLoading}
                        style={{
                            color: isButtonDisabled ? '#e5e5ee' : 'inherit'
                        }}
                    >
                        {countdown > 0 ? `${countdown}${loginInfo.seccond}` : identifyingString}
                    </Button>
                </div>
            )}
            {ok === 1 && (
                <Input
                    status={error ? 'error' : ''}
                    placeholder={loginInfo.enterPassword}
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        // 添加输入时错误清除
                        if (e.target.value.length >= 6) {
                            setError(null);
                        }
                    }}
                />
            )}
            {error && (
                <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                    {error}
                </div>
            )}

            <Button type="primary" onClick={goLogin}>{loginInfo.loginName}</Button>
            {ok === 1 && (
                <div className='login-bottom'
                    style={{
                        color: isHovered ? themeColor : "inherit"
                    }}
                    onClick={toAcountVerification}
                    onMouseEnter={() => { setIsHovered(true); }}
                    onMouseLeave={() => { setIsHovered(false); }}
                >{loginInfo.forget}?</div>
            )}
        </div>
    );
};

export default PhoneVerification;